import { AppState } from 'Store'
import { SETTING_KEY_USER } from 'Modules'

const getAll = (state: AppState) => state.modules.userSetting?.settings?.data

export const getSettings = (key: SETTING_KEY_USER) => (state: AppState) =>
	state.modules.userSetting?.settings?.data[key] ?? null

export const userSettingSelectors = {
	getAll,
	getSettings,
}
